var getChipSize = function getChipSize(size) {
  return size !== null && size !== void 0 ? size : 'm';
};
var getIconSize = function getIconSize(size, isTwoLine) {
  if (isTwoLine === true) return '16';
  return size === 's' ? '16' : '20';
};
var getTextColor = function getTextColor(selection, state, exp) {
  if (state === 'disabled') return 'base.disabled';
  if (selection === 'selected') {
    return exp !== null && exp !== void 0 && exp.isMigratingChipToAccessibleColor ? 'product.on.primary.subtle' : 'product.primary';
  }
  return 'deprecated.secondary.interactive';
};
var mapIcon = function mapIcon(props, iconId, isTwoLine, exp) {
  var size = props.size,
    iconLabel = props.iconLabel,
    selection = props.selection,
    state = props.state;
  return iconId && {
    id: iconId,
    size: getIconSize(size, isTwoLine),
    label: iconLabel,
    color: getTextColor(selection, state, exp)
  };
};
var interactiveStateProps = function interactiveStateProps(props) {
  var state = props.state;
  if (state === 'disabled') return {
    cursor: 'default'
  };
  return {
    interactive: 'product.primary',
    cursor: 'pointer'
  };
};

export { getChipSize, getTextColor, interactiveStateProps, mapIcon };
//# sourceMappingURL=shared.js.map
